import { useEffect, useState } from 'react'
import './index.less'
import { Col } from 'antd'
const RecommendRate = (props: any) => {
    const { isRate = false, } = props
    const [recommendedLevel, setRecommendedLevel] = useState<any>(0)
    const changeNpsNum = (index) => {
        if(props?.disabled) return;
        props?.onChange&&props?.onChange(index);
        props?.onChange&&setRecommendedLevel(index);
    }
    useEffect(() => {
        setRecommendedLevel(props?.recommendedLevel)
    }, [props?.recommendedLevel])

    const divs = Array.from({ length: props?.totalCount || 10  }, (_, index) => (
        <div
        key={index}
        className={`npsItem ${(index +1 )== recommendedLevel ? 'npsItemActive' : ''}`}
        onClick={() =>{changeNpsNum(index + 1)}}
        style={{cursor: props?.disabled ? 'default': 'pointer' }}>
            <view className="npsTxt">{index + 1}</view>
        </div>
    ));
    return (
        <div className="npsBox">
            {
                !isRate ? <Col><>{props?.required ? <span style={{color: 'red', paddingRight: '4px'}}>*</span> : <></>}<span>您愿意把我们(或我们的产品/服务)推荐给朋友吗?</span></></Col>:null
            }
            <div>
                {
                    isRate?<div className="npsTop" style={{display: 'flex', justifyContent: 'space-between'}}>
                        <span>很不满意</span>
                        <span>非常满意</span>
                    </div>:<div className="npsTop" style={{display: 'flex', justifyContent: 'space-between'}}>
                        <span>非常不愿意</span>
                        <span>非常愿意</span>
                    </div>
                }
                <div className="npsContent justify-between" style={{display: 'flex', justifyContent: 'space-between'}}>
                    {divs}
                </div>
            </div>
        </div>
    )
}

export default RecommendRate
